/*
  Vuex plugin pattern: https://vuex.vuejs.org/en/plugins.html, 
*/

import Vue from 'vue'

const mutationLookup = {
  // GET_CURRENT_PAGE(store){
  //     return {
  //         complete_pages: store.factory.complete_pages,
  //         complete_percent: store.factory.complete_percent,
  //     }
  // },
  // UPDATE_SAVE_PAYLOAD(store){
  //       return {
  //           saved_data: store.factory.save_payload
  //       }
  // },
  // UPDATE_FACTORY_ITEMS(store){
  //   if (store.factory.back) {
  //     return {
  //         clicked_back: store.factory.back
  //     }
  //   }
  // }
  TRIGGER_ANALYTICS(store){
    return{
      complete_pages: store.factory.complete_pages,
      complete_percent: store.factory.complete_percent,
      saved_data: store.factory.save_payload,
      clicked_back: store.factory.back,
      canopyLookupFail: store.funnel.elements.vx_notify_warning !== undefined && store.funnel.elements.vx_notify_warning.text === "We weren't able to get any information."
    }
  }
}

export default function gtmPlugin(store) {
  store.subscribe((m, s) => {
    try {
      let mutation = m.type.split('/')[0]
      let payload = mutationLookup[mutation] && mutationLookup[mutation](s)

      if (payload && Vue.gtm !== undefined) {
        Vue.gtm.trackEvent({
          event: 'route-change',
          noninteraction: mutation,
          ...payload
        })
      }
    } catch(e) {
      throw new Error(`gtmPlugin VueX: Error with gtm.trackEvent: ${e}`)
    }
  })
}